export function loadImage(imgSrc: string, isCrossOrigin = false): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const img = new Image();

    if (isCrossOrigin) {
      img.crossOrigin = '';
    }

    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = imgSrc;
  });
}
